import React, { useMemo, useState } from "react";
import { Fade } from "@mui/material";
import IconQuestion from "../../assets/images/question_icon.png";
import IconEducation from "../../assets/images/education_arrow.png";
import Group3 from "./images/Group_3.png";
import Estetic1 from "./images/estetic1.png";
import Estetic2 from "./images/estetic2.png";
import Estetic3 from "./images/estetic3.png";
import "./index.scss";
import { useTranslation } from "../../i18n";

const EducationStep1 = ({
  stepId
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const sectionsImg = useMemo(() => {
    switch (language) {
      case "ru":
        return require("./images/sections_ru.png");

      case "en":
        return require("./images/sections_en.png");

      default:
        return require("./images/sections_en.png");
    }
  }, [language]);
  const [educationTab, setEducationTab] = useState(1);
  const eduInfo = useMemo(() => {
    switch (stepId) {
      case "PSP_ET_e1":
        return {
          tabText1: _t("Что такое формула зубов? <br /> Как считается нумерация зубов?"),
          contentImg1: [sectionsImg],
          contentText1: _t("<b>Формула зубов</b> - это схема, при помощи которой можно идентифицировать каждый зуб на челюсти. Каждый зуб имеет свой номер, таким образом информацию о каждом зубе можно фиксировать. Номер зуба состоит из двух цифр. Например: 11. Первая цифра это номер сегмента челюсти. Всего 4 сегмента. Верхняя правая обозначается цифрой 1, верхняя левая 2, нижняя левая 3, нижняя правая 4. Вторая цифра - это номер зуба от центральной линии лица."),
          tabText2: _t("Как определить номера отсутствующих зубов?"),
          contentImg2: [{
            img: Group3
          }],
          contentText2: _t("Для того чтобы понять, какие именно зубы отсутствуют, воспользуйтесь панорамным снимком. Зная, как нумеруются зубы на челюсти, Вы сможете определить по снимку отсутствующие зубы и их номер.")
        };

      case "PSP_EM_e1":
        return {
          tabText1: _t("Что такое формула зубов? <br /> Как считается нумерация зубов?"),
          contentImg1: [sectionsImg],
          contentText1: _t("<b>Формула зубов</b> - это схема, при помощи которой можно идентифицировать каждый зуб на челюсти. Каждый зуб имеет свой номер, таким образом информацию о каждом зубе можно фиксировать. Номер зуба состоит из двух цифр. Например: 11. Первая цифра это номер сегмента челюсти. Всего 4 сегмента. Верхняя правая обозначается цифрой 1, верхняя левая 2, нижняя левая 3, нижняя правая 4. Вторая цифра - это номер зуба от центральной линии лица."),
          tabText2: _t("Как улучшить эстетику реставрациями?"),
          contentImg2: [{
            img: Estetic1,
            text: _t("В зоне эстетики 6 передних зубов верхней челюсти.")
          }, {
            img: Estetic2,
            text: _t("В зоне эстетики 8 передних зубов верхней челюсти.")
          }, {
            img: Estetic3,
            text: _t("В зоне эстетики 10 передних зубов верхней челюсти.")
          }],
          contentText2: _t("Для того чтобы определить, сколько нужно реставрировать зубов для достижения хорошей эстетики, необходимо определить ширину улыбки. То количество зубов, которые визуализируются при широкой улыбке считается зоной эстетики. Для того чтобы ее определить достаточно улыбнуться перед зеркалом и посчитать количество зубов на верхней челюсти, которое вы увидите. Для определения эстетической зоны мы рекомендуем Вам сделать это и определить номера зубов, форму и цвет которых Вы хотели бы изменить. Использовать эту информацию Вы сможете на дальнейших шагах этой программы. Если при улыбке вы видите шесть передних зубов верхней челюсти, значит достаточно провести реставрацию 31, 12, 11, 21, 22, 23 зубов. Но стоит учитывать, что и при широкой улыбке у многих людей видны четвертые и пятые зубы. В таком случае стоит включить в план реставраций и 14, 15, 24, 25 зубы. Обратите внимание также на то, насколько сильно видны нижние зубы при улыбке. От этого зависит нужно ли будет включать нижние зубы в план реставраций.  На следующих этапах программы мы предлагаем Вам самостоятельно составить план реставрации и обсудить его с врачом.")
        };

      default:
        return null;
    }
  }, [_t, sectionsImg, stepId]);

  if (!eduInfo) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "educationStep1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-tabs"
  }, /*#__PURE__*/React.createElement("img", {
    src: IconQuestion,
    className: "educationStep1-tabs-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-switcher"
  }, /*#__PURE__*/React.createElement("button", {
    className: `${educationTab === 1 ? "active" : ""}`,
    onClick: () => {
      setEducationTab(1);
    },
    dangerouslySetInnerHTML: {
      __html: eduInfo.tabText1
    }
  }), /*#__PURE__*/React.createElement("img", {
    src: IconEducation,
    className: `educationStep1-switcher-arrow ${educationTab === 1 ? "right" : "left"}`,
    alt: ""
  }), /*#__PURE__*/React.createElement("button", {
    className: `${educationTab === 2 ? "active" : ""}`,
    onClick: () => {
      setEducationTab(2);
    },
    dangerouslySetInnerHTML: {
      __html: eduInfo.tabText2
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container"
  }, /*#__PURE__*/React.createElement(Fade, {
    in: educationTab === 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container-item-img"
  }, eduInfo.contentImg1.map((el, i) => /*#__PURE__*/React.createElement("div", {
    key: i
  }, /*#__PURE__*/React.createElement("img", {
    src: el,
    alt: ""
  })))), /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container-item-text",
    dangerouslySetInnerHTML: {
      __html: eduInfo.contentText1
    }
  }))), /*#__PURE__*/React.createElement(Fade, {
    in: educationTab === 2
  }, /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container-item-img"
  }, eduInfo.contentImg2.map((el, i) => /*#__PURE__*/React.createElement("div", {
    key: i
  }, /*#__PURE__*/React.createElement("img", {
    src: el.img,
    alt: ""
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: "center",
      fontWeight: "bold",
      marginTop: 10
    }
  }, el.text)))), /*#__PURE__*/React.createElement("div", {
    className: "educationStep1-container-item-text",
    dangerouslySetInnerHTML: {
      __html: eduInfo.contentText2
    }
  })))));
};

export default EducationStep1;